export default __webpack_public_path__ + "static/media/cert-student-consumer.0064ab19.jpg";